module.exports = __webpack_public_path__ + "img/bg_avatar_male_53.3baf5df1.png";